import { type FC } from "react";
import Modal from "@root/shared/components/Modal";
import { Link } from "@root/shared/components/Link";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { EntryNote } from "@clientFrontend/features/awardsEntry/components/EntryNote";
import * as styles from "./styles.css";

type Section = {
  name: string;
  description: string;
};

type Props = {
  isShow: boolean;
  onClose: () => void;
  onClick: () => void;
  divisionName: string;
  divisionDescription: string;
  sections: Section[];
  imagesPath: string[];
  entryNote: string[];
  entryUrl: string;
};

export const Presentation: FC<Props> = ({
  isShow,
  onClose,
  onClick,
  divisionName,
  divisionDescription,
  sections,
  imagesPath,
  entryNote,
  entryUrl,
}) => {
  return (
    <>
      <button type="button" className={styles.detailButton} onClick={onClick}>
        詳細を見る
      </button>
      <Modal isShow={isShow} headerTitleStyle="none" onClose={onClose}>
        <div className={styles.modalInner}>
          <p className={styles.divisionName}>{divisionName}</p>
          <p className={styles.divisionDescription}>{divisionDescription}</p>
          {sections.map((section, index) => (
            <div key={section.name} className={styles.sectionWrapper}>
              <p className={styles.sectionName}>{section.name}</p>
              <div className={styles.sectionDescriptionWrapper}>
                <p className={styles.sectionDescription}>{section.description}</p>
                <div className={styles.sectionImageWrapper}>
                  {imagesPath[index] && (
                    <LazyLoadImage
                      height={100}
                      width={180}
                      src={imagesPath[index]}
                      alt={section.name}
                    />
                  )}
                </div>
              </div>
            </div>
          ))}
          <div className={styles.entryNoteWrapper}>
            <EntryNote entryNote={entryNote} />
          </div>
          <Link
            theme="primary"
            href={entryUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
          >
            一次エントリーフォームへ
          </Link>
        </div>
      </Modal>
    </>
  );
};
